import React, { useState, useEffect } from "react";
import {
  Button,
  Statistic,
  Card,
  DatePicker,
  Input,
  Row,
  Col,
  Form,
  theme,
  Badge,
  Modal,
  Spin,
  Radio,
  Image,
  Grid,
} from "antd";
import { useRewardsPageSrv } from "./useRewardsPageSrv";
import BrandColors from "@brand-colors";
import { CheckCircleTwoTone } from '@ant-design/icons';
import WallmartImage from "assets/img/walmart_logo.png";
import TargetImage from "assets/img/target_logo.png";
import QrImage from "assets/img/randomqr-256.png";
import { useTranslation } from "react-i18next";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useNavigate } from "react-router-dom";
import { usePageTitle } from "helpers/usePageTitle";

const RewardsPage = () => {
  const { t } = useTranslation();
  usePageTitle("REWARDS_PAGE.PAGE_TITLE", `Rewards - ${process.env.REACT_APP_PRODUCT}`);
  const [giftPoints, setGiftPoints] = useState([]);
  const [showGift, setShowGift] = useState(false);
  const [formData, setFormData] = useState({ Date: "", Reason: "" });
  const [remainGiftSummary, setRemainGiftSummary] = useState(0);
  const [giftSummary, setGiftSummary] = useState(0);
  const rewardService = useRewardsPageSrv();
  const [enableGift, setEnableGift] = useState(false);
  const [input1, setInput1] = useState("");
  const [date, setDate] = useState(null);
  const { useToken } = theme;
  const { token } = useToken();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isClaimProcessing, setIsClaimProcessing] = useState(false);
  const [isClaimed, setIsClaimed] = useState(false);
  const [claimAmount, setClaimAmount] = useState(0);
  const [isHover, setIsHover] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const navigate = useNavigate();
  let value: any[]

  const showModal = (RewardValue: any) => {
    setIsModalVisible(true);
    setClaimAmount(RewardValue)
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleClaim = () => {
    setIsClaimProcessing(true);
    setTimeout(() => {
      setIsClaimed(true);
      setIsClaimProcessing(false);
    }, 2000);
  };
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };

  const styles = {
    container: {
      margin: "0 auto",
      maxWidth: "450px",
      textAlign: "center",
      backgroundColor: token.colorBgContainer,
      zIndex: 100,
    },

    header: {
      maxWidth: "85%",
      padding: "20px 0",
      margin: " 0 auto",
      fontWeight: "600",
    },
    mainheader: {
      height: "80px",
      padding: "15px 0",
      backgroundColor: BrandColors.HEADER_BG,
    },
    subheader: {
      maxWidth: "100%",
      borderTop: "1px solid #cccccc",
    },

    text: {
      color: "#333",
      fontSize: "12px",
      lineHeight: "21px",
    },

    button: {
      backgroundColor:  BrandColors.BUTTON_BG,
      borderColor: BrandColors.BUTTON_BG,
      color: token.colorBgContainer,
      height: "42px",
      textTransform: "uppercase",
      fontWeight: "500",
      width: "auto",
      boxShadow: "none",
      padding: "0px 20px;"
    },    
    buttonNew: {
      backgroundColor: isHover ? token.colorBgContainer : BrandColors.BUTTON_BG,
      borderColor: BrandColors.BUTTON_BG,
      color: isHover ? BrandColors.BUTTON_BG : token.colorBgContainer,
      height: "42px",
      textTransform: "uppercase",
      fontWeight: "500",
      width: screens.md ? "auto" : "100%",
      boxShadow: "none",
      padding: "0px 20px;"
    },    
  };

  const searchGift = async () => {
    const formattedDate = date ? date.format("MM/DD/YYYY") : "";
    const rewardName = input1 ? encodeURIComponent(input1) : "";
    const resGift: any = await rewardService.httpgetGiftCardDetails(
      formattedDate,
      rewardName
    );
    setGiftPoints(resGift.data);

  }

  const fetchGiftCardDetails = async () => {
    try {
      const resGift: any = await rewardService.httpgetGiftCardDetails(
        formData.Date,
        formData.Reason
      );
      if (Array.isArray(resGift.data)) {
        setGiftPoints(resGift.data);
        setGiftSummary(findSum(resGift.data));
        setRemainGiftSummary(findRemain(resGift.data));
      } else {
        console.error("gifts data is not an array:", resGift.data);
      }
    } catch (e) {
      handleErrorNavigation(e,navigate,t)
    }
  };

  useEffect(() => {
    fetchGiftCardDetails();
  }, [formData]);

  const findSum = (rewardData: any) => {
    let total = 0;
    let redeem = 0;
    value = rewardData;
    for (let j = 0; j < rewardData.length; j++) {
      if (value[j].RewardPointStatus === '120000001')
        redeem += value[j].RewardValue ?? value[j].RewardPoint;
      else total += value[j].RewardValue ?? value[j].RewardPoint;
    }
    total = total - redeem;
    return total;
  }

  const findRemain = (rewardData: any) => {
    let remainGiftPoint = 0;
    for (let j = 0; j < rewardData.length; j++) {
      if (value[j].RewardType == '120000003') {
        if (value[j].RewardValueStatus === '120000000') {
          remainGiftPoint += value[j].RewardValue;
        }
      }
    }
    return remainGiftPoint;
  }

  const openGift = () => {
    setInput1("");
    setDate(null);
    setEnableGift(true);
    clearValues();
    setShowGift(!showGift);
  };

  const clearValues = () => {
    setFormData({ Date: "", Reason: "" });
  };

  function formatRewardDate(dateString: string | number | Date) {
    const date = new Date(dateString);
    const month = date.toLocaleString("default", { month: "short" });
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  }

  return (
    <>
      <div data-testid="rewards-page">
        <Card style={{  margin: "0px", borderRadius: "0px" }}>
          <div className="section-container">
            <Row gutter={0}>
              <Col span={24}>
                <Card
                  bordered={false}
                  style={{
                    backgroundColor: "#5e4ad2",
                    color: "#fff",
                    borderRadius: "5px",
                    textAlign: "center",
                    marginBottom: "0px"
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      style={{ flex: 1 }}
                      role="button"
                      tabIndex={0}
                      aria-label={t("REWARDS_PAGE.GIFT_CARD_AMOUNT")}
                      onClick={openGift}
                      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openGift(); } }}
                      data-testid="gifts-total"
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <Statistic valueStyle={{ color: '#fff',fontSize: screens.lg ? "40px" : "25px",fontWeight:"bold" }}
                          value={`$ ${remainGiftSummary} / ${giftSummary}`}
                        />
                        <p style={{margin:"0", fontSize: screens.lg ? "20px" : "16px"}}>{t("REWARDS_PAGE.GIFT_CARD_AMOUNT")}</p>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
          {enableGift && (
            <div
              style={{
                border: "1px solid black",
                padding: "10px",
                width: "100%",
                backgroundColor: "#2d3246",
                display: "flex",
                flexDirection: screens.md ? "row" : "column",
                alignItems: screens.md ? "center" : "end",
                // justifyContent: "space-between",
                marginBottom: "20px",
                marginTop: "16px",
                columnGap: "15px",
                rowGap: screens.md ? "0" : "10px",
              }}
            >
              <div style={{width: screens.md ? "auto" : "100%"}}>
                <label htmlFor="input1" style={{
                  color: "white", 
                  // display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 0,
                  fontWeight: "500",
                  fontSize: "16px",
                  marginRight:"10px"
                }}>
                  {t("REWARDS_PAGE.GIFT_NAME")}
                </label>
                <Input
                  data-testid="name-gift"
                  type="text"
                  id="input1"
                  aria-label={t("REWARDS_PAGE.GIFT_NAME")}
                  value={input1}
                  onChange={(e) => setInput1(e.target.value)}
                  style={{ width: screens.md ? "auto" : "100%", padding: "10px 20px", boxSizing: "border-box", fontSize: "12px", fontWeight: "bold", border: "1px solid #cccccc !important", boxShadow: "none !important", color: "#333333" }}
                />
              </div>

              <div style={{width: screens.md ? "auto" : "100%"}}>
                <label htmlFor="date" style={{
                  color: "white", 
                  // display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 0,
                  fontWeight: "500",
                  fontSize: "16px",
                  marginRight:"10px"
                }}>
                  {t("REWARDS_PAGE.DATE")}
                </label>
                <DatePicker
                  data-testid="date-gift"
                  className="form-control form-control-sm"
                  id="date"
                  selected={date}
                  onChange={(date) => setDate(date)}
                  dateFormat="MM/dd/yyyy" // Set the date format here
                  style={{ width: screens.md ? "auto" : "100%", padding: "10px 20px", boxSizing: "border-box", fontSize: "12px", fontWeight: "bold", border: "1px solid #cccccc !important", boxShadow: "none !important", color: "#333333" }}
                />
              </div>
              <Form.Item style={{ marginBottom: "0px", width: screens.md ? "auto" : "100%" }}>
                <Button
                  block={true}
                  type="primary"
                  data-testid="search-gift"
                  onClick={() => searchGift()}
                  style={styles.buttonNew}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  id="rewards-search-btn"
                >
                  {t("REWARDS_PAGE.SEARCH")}
                </Button>
              </Form.Item>
            </div>
          )}
          <div className="section-container">
            {enableGift && (
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {giftPoints
                  ? giftPoints.map((gift: {
                    RewardCode: string | undefined; PatientGiftCardID: React.Key | null | undefined; PatientGiftCardName: any; RewardValueStatus: number; RewardOn: any; RewardType: string | number; RewardProviderName: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Iterable<React.ReactNode> | null | undefined; RewardValue: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | Iterable<React.ReactNode> | null | undefined; IsEvergreen: any; ValidUntil: any;
                  }) => {
                    return (
                      <Col span={12} key={gift.PatientGiftCardID} style={{maxWidth: screens.md ? "50%" : "100%", flex: screens.md ? "0 0 50%" : "0 0 100%"}}>
                        <Card
                          title={
                            <div>
                              {`${gift.PatientGiftCardName}`}
                              {gift.RewardValueStatus === 120000000 ? (
                                <div
                                  style={{
                                    backgroundColor: "#00000008",
                                    marginLeft: "0px",
                                    width: "83px",
                                  }}
                                >
                                  <Badge>{t("REWARDS_PAGE.INCOMPLETE")}</Badge>
                                </div>
                              ) : (
                                <span
                                  style={{
                                    backgroundColor: "#28a745",
                                    marginLeft: "8px",
                                    float:"right",
                                    color:"#fff",
                                    padding:"4px",
                                    borderRadius:"4px",
                                    lineHeight:"1",
                                    fontSize:"14px"
                                  }}
                                >
                                  {t("REWARDS_PAGE.READY_TO_CLAIM")}
                                </span>
                              )}
                            </div>
                          }
                          bordered={false}
                          style={{
                            // width: "100%",
                            marginRight: screens.md ? "16px" : "0px",
                            marginBottom: 16,
                          }}
                        >
                          {
                            gift.RewardValueStatus === 120000001 ? <> <p style={{marginTop:"0", marginBottom:"4px"}}>{formatRewardDate(gift.RewardOn)}</p><p style={{marginTop:"0", marginBottom:"4px"}}>{gift.RewardProviderName}</p><p style={{marginTop:"0", marginBottom:"4px"}}>{t("REWARDS_PAGE.GIFT_VALUE")}${gift.RewardValue} ${gift.RewardValue}</p><a type="text" href={gift.RewardCode}  style={{marginTop:"0",textAlign:"right", marginBottom:"15px",display:"block"}}>{t("REWARDS_PAGE.DOWNLOAD")}</a></>: ""
                          }
                          {
                            gift.RewardValueStatus === 120000000 ? <><p style={{marginTop:"0"}}>Gift Value : ${gift.RewardValue}</p><p>{gift.RewardCode}</p></> : ""
                          }
                          <div>
                            <Button id="rewards-claim-now-btn" style={styles.button} type="primary" data-testid="claim-now"  onClick={() => showModal(gift.RewardValue)}>
                            {t("REWARDS_PAGE.CLAIM_NOW")}
                            </Button>
                            <Modal
                              title={t("REWARDS_PAGE.CLAIM")}
                              visible={isModalVisible}
                              onCancel={handleCancel}
                              footer={null}
                              destroyOnClose
                            >
                              {!isClaimed && (
                                <Form>
                                  <Form.Item>
                                    <Radio.Group>
                                      <Radio value="option1" data-testid="walmart-radio">
                                        <Image width={150} src={WallmartImage} preview={false} alt="Walmart Logo" />
                                      </Radio>
                                      <Radio value="option2" data-testid="target-radio">
                                        <Image width={150} src={TargetImage} preview={false} alt="Target Logo" />
                                      </Radio>
                                    </Radio.Group>
                                  </Form.Item>
                                  <Form.Item label={t("REWARDS_PAGE.CLAIM_AMOUNT")}>
                                    <Input readOnly aria-label={t("REWARDS_PAGE.CLAIM_AMOUNT")} value={claimAmount} />
                                  </Form.Item>
                                  <Form.Item>
                                    <Button id="rewards-claim-btn" style={styles.button} type="primary" data-testid="claim" onClick={handleClaim} disabled={isClaimProcessing}>
                                      {isClaimProcessing ? <Spin /> : t("REWARDS_PAGE.CLAIM")}
                                    </Button>
                                  </Form.Item>
                                </Form>
                              )}

                              {isClaimed && (
                                <div className="text-center">
                                  <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '36px' }} />
                                  <p className="display-6 text-primary">
                                  {`${t("REWARDS_PAGE.THANKYOU")} ${"$" + gift.RewardValue} ${t("REWARDS_PAGE.GIFT_CARD")}`}
                                  </p>
                                  <div className="row g-0">
                                    <div className="col-md-6 border-end">
                                      <div className="card-body">
                                        <Image src={WallmartImage} preview={false} />
                                        <p className="card-text mb-0">
                                        <small className="text-muted">{t("REWARDS_PAGE.GIFT_CARD_NUMBER")}</small>
                                        </p>
                                        <p className="card-text">
                                        <small className="text-muted">{t("REWARDS_PAGE.ACCESS_NUMBER")}</small>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <Image src={QrImage} preview={false} />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                      <Button id="rewards-close-btn" type="primary" data-testid="close" style={styles.button} onClick={handleCancel} block>
                                      {t("REWARDS_PAGE.CLOSE")}
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </Modal>
                          </div>
                        </Card>
                      </Col>
                    );
                  })
                  : ""}
              </div>
            )}
          </div>
        </Card>
      </div>
    </>
  );
};
export default RewardsPage;
